module.exports = {"430922101":"修山镇","430922103":"鸬鹚渡镇","430922107":"石牛江镇","430922108":"牛田镇","430922109":"松木塘镇","430922112":"桃花江镇","430922113":"灰山港镇","430922114":"武潭镇","430922115":"马迹塘镇","430922116":"三堂街镇","430922117":"大栗港镇","430922118":"沾溪镇","430922203":"高桥乡","430922208":"鲊埠回族乡","430922212":"浮丘山乡","430922400":"板溪林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430922.json
// module id = 1724
// module chunks = 0